var $b1114bef0e73e1c2$exports = {};
$b1114bef0e73e1c2$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}`
};


export {$b1114bef0e73e1c2$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
